module.exports = __webpack_public_path__ + "img/753890862.2af9f0a0.png";